<template>
  <Modal
    :modal-style="{ width: '500px' }"
    :title="title"
  >
    <!-- eslint-disable vue/no-v-html -->
    <div v-html="text" />
    <!-- eslint-enable vue/no-v-html -->
  </Modal>
</template>

<script>
import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "SimpleTextModal",
  components: {
    Modal,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
